<template>
  <div id="app" :class="{ 'is-loading': isLoading }">
    <el-container>
      <NavBar :screenWidth="screenWidth" />
      <!-- Main Content -->
      <el-main class="app-main">
        <transition name="fade" mode="out-in">
          <router-view v-if="!isLoading" :swidth="screenWidth" />
          <div v-else class="loading-spinner">
            <el-spinner></el-spinner>
          </div>
        </transition>
      </el-main>

      <!-- Footer -->
      <el-footer class="app-footer">
        <Bottom :screenWidth="screenWidth"></Bottom>
      </el-footer>
    </el-container>

    <div v-if="$route.name === 'home' && screenWidth >= 1280" class="footer__join global-padding">
      <div class="left-word">{{ $t("bottom.p5") }}</div>
    </div>

    <div class="float-ball" :style="{ left: ballPosition.x + 'px', top: ballPosition.y + 'px' }" draggable="true"
      @dragstart="onDragStart" @drag="onDrag" @dragend="onDragEnd" @touchstart.prevent="onBallTouchStart"
      @touchmove.prevent="onBallTouchMove" @touchend.prevent="handleTouchEnd" ref="floatBall" v-show="!isIE">
      <img class="ball-icon" :draggable="false" @click="searchCoz"
        src="https://636c-cloud1-2gpwvye3d73a9a45-1307902814.tcb.qcloud.la/ai-service.png?sign=e0f5d2d83ada7d4b416f1ef98a276268&t=1737447774" />
    </div>
  </div>
</template>

<script>
import NavBar from './components/navBar/Navbar.vue'
import Bottom from './components/Bottom.vue'
export default {
  name: 'App',
  components: {
    NavBar, Bottom
  },
  data() {
    return {
      isLoading: false,
      currentLang: 'zh_cn',
      screenWidth: window.innerWidth || document.documentElement.clientWidth || 1280,
      menus: [{
        rou: 'template',
        name: '路由a'
      }, {
        rou: 'template2',
        name: '路由2'
      }],
      showMPanel: false,
      ballPosition: {
        x: 9999,
        y: 9999
      },
      isDragging: false,
      startPos: {
        x: 0,
        y: 0
      },
      touchStartTime: 0,
      touchStartPos: { x: 0, y: 0 },
      isIE: window.isIE
    }
  },
  methods: {
    searchCoz() {
      if (typeof cozeWebSDK !== 'undefined') {
        cozeWebSDK.showChatBot();
      } else {
        console.warn('cozeWebSDK is not defined')
      }
    },
    changeLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('333f-locale-lang', lang)
    },
    // gotoCoz() {
    //   if (!this.isDragging)
    //     window.location.href = "https://show.333f.com/pazhou-ai-session-client/";
    // },
    setFloatPosition() {
      let w = this.screenWidth
      let h = window.innerHeight || document.documentElement.clientHeight
      // if (w > 1280) {
      this.ballPosition.x = w - 70
      this.ballPosition.y = h * .9 - 80
    },
    handleResize() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth
      this.setFloatPosition()
    },
    onDragStart(e) {
      this.isDragging = true
      // 设置拖拽时的透明度
      e.target.style.opacity = '0.8'
      // 记录起始位置的偏移量
      this.startPos = {
        x: e.clientX - this.ballPosition.x,
        y: e.clientY - this.ballPosition.y
      }
    },
    onDrag(e) {
      if (!e.clientX || !e.clientY) return

      const ball = this.$refs.floatBall
      const ballWidth = ball.offsetWidth
      const ballHeight = ball.offsetHeight

      let x = e.clientX - this.startPos.x
      let y = e.clientY - this.startPos.y

      // 限制边界
      const maxX = window.innerWidth - ballWidth
      const maxY = window.innerHeight - ballHeight - 90

      x = Math.max(0, Math.min(x, maxX))
      y = Math.max(0, Math.min(y, maxY))

      this.ballPosition = { x, y }
    },

    onDragEnd(e) {
      this.isDragging = false
      e.target.style.opacity = '1'

      // 自动贴边逻辑
      const ball = this.$refs.floatBall
      const ballWidth = ball.offsetWidth
      const windowWidth = window.innerWidth
      const targetX = this.ballPosition.x > windowWidth / 2 ?
        windowWidth - ballWidth - 20 : 20

      // 添加动画过渡
      ball.style.transition = 'left 0.3s ease'
      this.ballPosition.x = targetX

      // 动画结束后移除过渡效果
      setTimeout(() => {
        ball.style.transition = ''
      }, 300)
    },
    // 触摸开始事件
    onBallTouchStart(e) {
      this.isDragging = false
      this.touchStartTime = Date.now()
      const touch = e.touches[0]
      this.touchStartPos = {
        x: touch.clientX,
        y: touch.clientY
      }
      this.startPos = {
        x: touch.clientX - this.ballPosition.x,
        y: touch.clientY - this.ballPosition.y
      }
    },

    // 触摸移动事件
    onBallTouchMove(e) {
      // 判断是否应该开始拖动
      const touch = e.touches[0]
      const moveDistance = Math.sqrt(
        Math.pow(touch.clientX - this.touchStartPos.x, 2) +
        Math.pow(touch.clientY - this.touchStartPos.y, 2)
      )

      // 如果移动距离大于10px，则认为是拖动
      if (moveDistance > 10) {
        this.isDragging = true
      }

      if (this.isDragging) {
        e.preventDefault() // 阻止页面滚动
        const touch = e.touches[0]
        const ball = this.$refs.floatBall
        const ballWidth = ball.offsetWidth
        const ballHeight = ball.offsetHeight

        let x = touch.clientX - this.startPos.x
        let y = touch.clientY - this.startPos.y

        // 限制边界
        const maxX = window.innerWidth - ballWidth
        const maxY = window.innerHeight - ballHeight

        x = Math.max(0, Math.min(x, maxX))
        y = Math.max(0, Math.min(y, maxY))

        this.ballPosition = { x, y }
      }
    },
    // 新增触摸结束处理方法
    handleTouchEnd(e) {
      let dn = Date.now()
      const touchDuration = dn - this.touchStartTime
      // 如果触摸时间小于200ms且没有拖动，则视为点击
      if (touchDuration < 200 && !this.isDragging) {
        this.searchCoz()
      } else if (this.isDragging) {
        this.onBallTouchEnd()
      }

      this.isDragging = false
    },
    // 触摸结束事件
    onBallTouchEnd() {
      if (this.isDragging) {
        this.isDragging = false

        // 自动贴边逻辑
        const ball = this.$refs.floatBall
        const ballWidth = ball.offsetWidth
        const windowWidth = window.innerWidth
        const targetX = this.ballPosition.x > windowWidth / 2 ?
          windowWidth - ballWidth - 20 : 20

        // 添加动画过渡
        this.$refs.floatBall.style.transition = 'left 0.3s ease'
        this.ballPosition.x = targetX

        // 动画结束后移除过渡效果
        setTimeout(() => {
          this.$refs.floatBall.style.transition = ''
        }, 300)
      }
    },
  },
  mounted() {
    // 添加窗口大小变化监听器
    let that = this
    window.addEventListener('resize', () => {
      // setTimeout(() => {
      that.handleResize()
      // }, 300);
    })
    this.setFloatPosition()
  },
  created() {
    this.currentLang = localStorage.getItem('333f-locale-lang') || 'zh_cn'
    this.$i18n.locale = this.currentLang
  },
  // errorCaptured(err, vm, info) {
  //   console.error('Global error:', err)
  //   return false
  // },
  beforeDestroy() {
    // 移除监听器
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="less">
@import url(./assets/css/global.less);

/* Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

#app {
  color: #333;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

.el-container {
  height: 100%;
}

.app-header {
  // height: 70px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .8);
}

.header-content {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 20px;
}

.app-main {
  // margin-top: 80px;
  min-height: calc(100% - 320px);
  padding: 0;
  overflow-x: hidden;
}


.app-footer {
  height: 320px !important;
  background-color: rgba(0, 0, 0, .8);
  color: #fff;
}

.footer__join {
  height: 80px;
  // padding: 0 $normal-left;
  background-image: url("./assets/images/bottom.png");
  font-size: 32px;
  line-height: 80px;
  color: #fff;
}

.nav-menu {
  border: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.m-panel {
  width: 100%;
  height: calc(100% - 70px);
  top: 70px;
  right: 0;
  left: 0;
  z-index: 1000;
  position: fixed;
  background-color: rgba(0, 0, 0, .8);
}


.home-banner {
  .tns-nav {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    width: 30%;
    /* margin: auto; */
    z-index: 1;
  }
}

.home-company {
  position: relative;

  .tns-nav {
    position: absolute;
    bottom: 15px;
    left: 0;
    right: 0;
    width: 100%;
    /* margin: auto; */
    z-index: 1;
  }
}

.mask-creative {
  position: relative;

  .tns-nav {
    position: absolute;
    top: 67%;
    left: 0;
    right: 0;
    width: 100%;
    /* margin: auto; */
    z-index: 1;
  }
}

.fa8097ff55eabaa5782b {
  width: 40% !important;
}

// @media screen and (max-width: 80100px) {
//   .fa8097ff55eabaa5782b {
//     width: 90% !important;
//   }

// }
@media (max-width: 900px) {
  .home-banner {
    .tns-nav {
      width: 40%;
      bottom: 5px;
    }
  }

  .fa8097ff55eabaa5782b {
    width: 90% !important;
  }
}

.swiper-pagination-bullet {
  width: 20px;
  height: 3px;
  padding: 0;
  margin: 0 5px;
  /* border-radius: 50%; */
  background-color: rgba(255, 255, 255, 1);
  border: 0;
  border-radius: unset;
}

.swiper-pagination-bullet-active {
  background: @primaryColor;
  /* 当前激活的分页器小点的颜色 */
}

.home-banner {
  .swiper-pagination {
    width: 35%;
  }
}

.el-footer {
  padding: 0;
}

.float-ball {
  cursor: pointer;
  position: fixed;
  z-index: 1000;
  width: 60px;
  height: 60px;
  // background-color: #fff;
  // border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  // cursor: move;
  transition: left 0.3s ease;
  // box-shadow: 0 2px 12px 0 #ff5715;
  animation: mymove 2s infinite linear;

  img {
    width: 60px;
    height: 55px;
  }

  &:hover {
    opacity: 0.9;
  }
}

@keyframes mymove {
  0% {
    opacity: 0.9;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
  }

  100% {
    opacity: 0.9;
    transform: scale(1);
  }
}

@-webkit-keyframes mymove {

  /*Safari and Chrome*/
  0% {
    opacity: 0.9;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
  }

  100% {
    opacity: 0.9;
    transform: scale(1);
  }
}

.wangeditor {
  img {
    display: inline-block;
  }

}
</style>


// WEBPACK FOOTER //
// src/App.vue